import { render, staticRenderFns } from "./LineAuth.vue?vue&type=template&id=21cca1a8&scoped=true&"
import script from "./LineAuth.vue?vue&type=script&lang=ts&"
export * from "./LineAuth.vue?vue&type=script&lang=ts&"
import style0 from "./LineAuth.vue?vue&type=style&index=0&id=21cca1a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cca1a8",
  null
  
)

export default component.exports